var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractRepository } from 'packages/core/AbstractRepository';
import { DefaultPreferences } from 'packages/notifications/entities/DefaultPreferences';
import env from 'config/env.js';
var PreferencesRepository = /** @class */ (function (_super) {
    __extends(PreferencesRepository, _super);
    function PreferencesRepository() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.url = 'users/:id/preferences';
        _this.entity = DefaultPreferences;
        _this.baseUrl = env.NOTIFICATIONS_API;
        return _this;
    }
    PreferencesRepository.prototype.fetchForUser = function (userId) {
        return this.find(userId);
    };
    PreferencesRepository.prototype.setPreferences = function (preferences) {
        return this.create(preferences.preferences, { id: preferences.userId });
    };
    return PreferencesRepository;
}(AbstractRepository));
export { PreferencesRepository };
